import React from "react";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/Constants";
import Navigation, {NavigationRoutes} from "../util/Navigation";
import {INDUCT_MANAGEMENT_ROUTES} from "../util/RouteConstants";
import Column from "@amzn/meridian/column";
import {CycleManagementContext} from "./context/CycleManagementContext";
import {useContext, useEffect} from "react";
import Loader from "../loader/Loader";

const InductManagementDetail = ({history, location}) => {
    const {cycleViewModel, cycleDispatch} = useContext(CycleManagementContext)

    useEffect(() => {
        cycleDispatch({
            type: 'LOAD_VIEW',
            data: {dispatcher: cycleDispatch}
        })
    }, []);

    if (cycleViewModel.loadingCycle || cycleViewModel.loadingNode) {
        return (<Loader/>)
    }
    else {
        return (
            <Column>
                <PageHeader {...PAGE_HEADERS.INDUCT_MANAGEMENT}/>
                <Navigation routes={INDUCT_MANAGEMENT_ROUTES} location={location} history={history}/>
                <NavigationRoutes routes={INDUCT_MANAGEMENT_ROUTES}/>
            </Column>
        )
    }
}

export default InductManagementDetail




// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/InductManagementDetail.js